module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  crop: function () {
    var element = $('#svgcontent').find('.background').find('image').get(0);
    if (!element) {
      return;
    }
    var editorFacade = require('../editor');
    this.currentZoom = editorFacade.handle('zoom', 'get');
    this.trigger('crop.start', { id: element.getAttribute('id') });

    _.defer(_.bind(function () {
      this._fitZoomToImageSize(editorFacade, element);
      this.canvas.runExtensions('backgroundReposition', {
        layout: element,
        callback: _.bind(function () {
          this.trigger('crop.end', { id: element.getAttribute('id') });
          editorFacade.handle('zoom', 'set', { zoom: this.currentZoom });
        }, this)
      });
    }, this));
  },
  _fitZoomToImageSize: function (editorFacade, element) {
    var clipBox = svgedit.utilities.getBBox(element);
    if (clipBox) {
      editorFacade.handle('zoom', 'center', {
        x: clipBox.x + clipBox.height / 2,
        y: clipBox.y + clipBox.width / 2
      });
      editorFacade.handle('zoom', 'fit', clipBox);
      var newZoom = editorFacade.handle('zoom', 'get') / 1.2;

      if (newZoom > this.currentZoom) {
        newZoom = this.currentZoom;
      }
      editorFacade.handle('zoom', 'set', { zoom: newZoom });
    }
  }

}, Backbone.Events);
